<adapt-feature-guidance [configItem]="configItem">
    <p>Set the basic information about your organisation.</p>
</adapt-feature-guidance>

<div class="row"
     *ngIf="organisation">
    <div class="col-sm-8 col-md-4">
        <div class="form-group">
            <label for="name">Name</label>
            <dx-text-box id="name"
                         placeholder="Type your organisation name here"
                         [adaptValidateEntity]="organisation"
                         adaptValidateEntityProperty="name"
                         [(value)]="organisation!.name"
                         data-test="organisation-name-input"></dx-text-box>
        </div>

        <div class="form-group">
            <label for="site">Web site</label>
            <dx-text-box id="site"
                         placeholder="Type your organisation's website address here"
                         [adaptValidateEntity]="organisation"
                         adaptValidateEntityProperty="website"
                         [(value)]="organisation!.website">
            </dx-text-box>
        </div>

        <div class="form-group">
            <label for="logo">Logo</label>
            <adapt-select-image id="logo"
                                [imageIdentifier]="organisation!.imageIdentifier"
                                (imageIdentifierChange)="onImageIdentifierChange($event)"
                                [defaultImageSrc]="defaultImageSrcOrg"
                                imageHeight="120px"
                                imageWidth="100%"
                                [resizeHeight]="120"></adapt-select-image>
        </div>

        @if (account) {
            <div class="form-group">
                <label for="keyContactPerson">Key contact
                    <span class="fal fa-info-circle"
                          adaptTooltip="The key contact will be used by adapt for any information or communication that is not financial in nature."></span>
                </label>
                <adapt-select-person [(person)]="account.keyContactPerson"
                                     placeholder="Select a key contact for this organisation"
                                     [userTypes]="[UserType.Collaborator, UserType.Leader]">
                </adapt-select-person>
            </div>
        }
    </div>
</div>
